import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import InfoBanner from "./components/InfoBanner";
import HygieneInfo from "./components/HygieneInfo";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import EmergencyPrices from "./components/EmergencyPrices";
import AvailabilityCalendar from "./components/AvailabilityCalendar";
import AdvancedPriceCalculator from "./components/AdvancedPriceCalculator";
import Booking from "./components/Booking";
import Pfotenflatrate from "./components/Pfotenflatrate";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import ReviewForm from "./components/ReviewForm";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AdminPanel from "./components/AdminPanel";
import MembershipSuccess from "./components/MembershipSuccess";
import EmailVerification from "./components/EmailVerification";
import AGBPage from "./components/AGBPage";
import DatenschutzPage from "./components/DatenschutzPage";
import ImpressumPage from "./components/ImpressumPage";
import ComboTransportPage from "./components/ComboTransportPage";
import ConfirmRegistrationPage from "./components/ConfirmRegistrationPage";
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Anonymes Page Tracking (DSGVO-konform - nur Seitenaufrufe, keine persönlichen Daten)
const PageTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Bestimme Seitenname aus Pfad
    const path = location.pathname;
    let pageName = 'home';
    
    if (path === '/') pageName = 'home';
    else if (path.includes('/agb')) pageName = 'agb';
    else if (path.includes('/datenschutz')) pageName = 'datenschutz';
    else if (path.includes('/impressum')) pageName = 'impressum';
    else if (path.includes('/pfotenflatrate')) pageName = 'flatrate';
    else if (path.includes('/kombi-transport')) pageName = 'kombi-transport';
    else if (path.includes('/Admin')) pageName = 'admin';
    else pageName = path.replace(/^\//, '').replace(/\//g, '-') || 'home';
    
    // Skip tracking for admin pages (for privacy)
    if (pageName === 'admin') return;
    
    // Track page view
    axios.post(`${BACKEND_URL}/api/analytics/track?page=${encodeURIComponent(pageName)}`)
      .catch(() => {}); // Silently fail
  }, [location.pathname]);
  
  return null;
};

// Hauptseite Komponente
const MainPage = () => (
  <div className="flex flex-col min-h-screen">
    <InfoBanner />
    <Header />
    <HygieneInfo />
    <Hero />
    <About />
    <Services />
    <EmergencyPrices />
    <AvailabilityCalendar />
    <AdvancedPriceCalculator />
    <Booking />
    <Pfotenflatrate />
    <Gallery />
    <Testimonials />
    <ReviewForm />
    <Contact />
    <Footer />
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <PageTracker />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/Admin/Pfotenboss-Pfotenexpress" element={<AdminPanel />} />
          <Route path="/mitgliedschaft-erfolg" element={<MembershipSuccess />} />
          <Route path="/verifizieren" element={<EmailVerification />} />
          <Route path="/agb" element={<AGBPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/kombi-transport" element={<ComboTransportPage />} />
          <Route path="/vertrag-bestaetigen/:token" element={<ConfirmRegistrationPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
